module.exports = __webpack_public_path__ + "img/strategy-bg6.1bacdf73.jpg";